import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FooterService {

  constructor() { }

  private footerHeight: number;

  setFooterHeight(data): void {
    this.footerHeight = data;
  }

  getFooterHeight(): number {
    return this.footerHeight;
  }
}
